import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AjaxService } from 'AjaxService';
import { StaticVorlagenType, StaticVorlagenGruppen } from '@enums/staticVorlagen.enum';

@Component({
    selector: 'cz-download-button',
    templateUrl: './download-button.component.html',
    styleUrls: ['./download-button.component.css'],
    standalone: false
})
export class DownloadButtonComponent implements OnInit {
    @ViewChild('downloadButtonIntern', { static: true }) downloadButtonIntern: ElementRef;

    constructor(private ajaxService: AjaxService) { }

    ngOnInit(): void {
        this.downloadButtonIntern.nativeElement.style.cssText = this.styles;
    }

    @Input() styles: string = '';
    @Input() classes: string = 'btn btn-info btn-xs';
    @Input() text: string = '';

    // StaticVorlagen
    @Input() isForStaticVorlage: boolean = false;
    @Input() vorlagenType: StaticVorlagenType;
    @Input() gruppe: StaticVorlagenGruppen;
    @Input() entityId: string;

    // normale Dokumente
    @Input() fileName: string;
    @Input() fileBezeichnung: string;


    download() {
        if (!this.isForStaticVorlage) {
            this.ajaxService.post<string>('api/Dokument/CheckDocumentFileExist', { fileName: this.fileName, fileBezeichnung: this.fileBezeichnung }).subscribe(response => {
                if (response) {
                    this.ajaxService.download('/api/Dokument/Download?fileName=' + this.fileName + '&dokumentName=' + this.fileBezeichnung, response);
                }
            });
        }
        else if (this.isForStaticVorlage) {
            this.ajaxService.post<string>('api/vorlagenVerwaltung/CheckStaticVorlageFileExist', { vorlagenType: this.vorlagenType, gruppe: this.gruppe, id: this.entityId }).subscribe(response => {
                if (response) {
                    this.ajaxService.download('/api/vorlagenVerwaltung/GetVorlageDownload?vorlagenType=' + this.vorlagenType + '&gruppe=' + this.gruppe + '&id=' + this.entityId, response);
                }
            });
        }
    }
}
